import React, { useState, useEffect,useRef } from "react";
import {
  Box,
  HStack,
  VStack,
  Text,
  Center,
  ScrollView,
  Button,
  useToast,
  Stack,
  TextArea,
  View,
  FormControl,
  Pressable,
  Input,
  Icon,
  Image,
  ChevronUpIcon,
  IconButton,
} from "native-base";
import { GlobalStyles } from "../../constants/styles";
import FeedCard from "../../components/FeedCard";
import { GlobalConstants } from "../../constants/constants";
import { useNavigation } from "@react-navigation/native";
import Toast from "../../components/Toast";
import { useSelector } from "react-redux";
import axios from "axios";
import ConfigureSettingsPopup from "../../components/ConfigureSettingsPopup";
import { uploadImage } from "../../utils/general";
import { Ionicons, MaterialIcons } from "@expo/vector-icons";
import FeedCardNew from "../../components/FeedCardNew";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill's CSS

const CityLensMainPage = () => {
  let user = useSelector((state) => state.user.user);
  axios.defaults.headers.common = {
    Authorization: `bearer ${user ? user.token : null}`,
  };

  const toast = useToast();
  const navigation = useNavigation();

  const [postTextArea, setPostTextArea] = useState("");
  const [postDetails, setPostDetails] = useState("");
  const [postType, setPostType] = useState(
    GlobalConstants.postCategories.cityLen.id
  );
  const [postImage, setPostImage] = useState([]);
  const [youtubeLink, setYoutubeLink] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [ticksBtnTextColor, setTicksBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [addEventBtnTextColor, setAddEventBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [createAdBtnTextColor, setCreateAdBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [isTicksView, setIsTicksView] = useState(false);
  const [businessPosts, setBusinessPosts] = useState([]);
  const [hasMorePosts, setHasMorePosts] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [deletePopUp, setDeletePopUp] = useState(false);
  const [selectedPost, setSelectedPost] = useState({});
  const [remainingCharacters, setRemainingCharacters] = useState(300);
  const [remainingCharactersForDetail, setRemainingCharactersForDetail] = useState(1500);

  function changeColor(btnType) {
    if (btnType === "AddEvent") {
      setTicksBtnTextColor(GlobalStyles.colors.white);
      setAddEventBtnTextColor(GlobalStyles.colors.mustard);
      setCreateAdBtnTextColor(GlobalStyles.colors.white);
    } else if (btnType === "CreateAd") {
      setTicksBtnTextColor(GlobalStyles.colors.white);
      setAddEventBtnTextColor(GlobalStyles.colors.white);
      setCreateAdBtnTextColor(GlobalStyles.colors.mustard);
    } else if (btnType === "Ticks") {
      setTicksBtnTextColor(GlobalStyles.colors.mustard);
      setAddEventBtnTextColor(GlobalStyles.colors.white);
      setCreateAdBtnTextColor(GlobalStyles.colors.white);
    } else {
      setTicksBtnTextColor(GlobalStyles.colors.white);
      setAddEventBtnTextColor(GlobalStyles.colors.mustard);
      setCreateAdBtnTextColor(GlobalStyles.colors.white);
    }
  }

  const createPost = async () => {
    

    try {
      var obj = {
        text: postTextArea,
        details: postDetails,
        type: postType,
      };
  
      if (postImage.length > 0) {
        obj.urls = postImage; 
      }
      if (youtubeLink?.length > 0) {
        obj.urls = [youtubeLink];
        
      }
      setIsLoading(true);
      console.log(postType, postTextArea);
      const resp = await axios.post(
        `${GlobalConstants.townTicksBaseUrl}posts`,
        obj
      );
      if (resp.data.status) {
        setPostImage([]);
        setPostTextArea("");
        setPostDetails("");
        setYoutubeLink("");
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.mustard}
                message={"tick created successfuly!!!"}
              />
            );
          },
          placement: "top",
        });
      } else {
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.red}
                message={resp.data.status_msg}
              />
            );
          },
          placement: "top",
        });
      }
      setPostTextArea("");
      setPostDetails("");
      setYoutubeLink("");
      setIsLoading(false);
    } catch (error) {
      changeColor("AddEvent");
      console.log(error);
    }
  };

  const handleCountInputChange = (value) => {
    
    const plainTextLength = value.replace(/<[^>]*>/g, "").length;

    if (plainTextLength <= 300) {
      setPostTextArea(value);
      setRemainingCharacters(300 - plainTextLength);
    } else {
      const truncatedText = truncateToLimit(value, 300);
      setPostTextArea(truncatedText);
      setRemainingCharacters(0);
    }
  };
  const handleCountInputChangeForDetail = (value) => {
    
    const plainTextLength = value.replace(/<[^>]*>/g, "").length;

    if (plainTextLength <= 1500) {
      setPostDetails(value);
      setRemainingCharactersForDetail(1500 - plainTextLength);
    } else {
      const truncatedText = truncateToLimit(value, 1500);
      setPostDetails(truncatedText);
      setRemainingCharactersForDetail(0);
    }
  };

  const truncateToLimit = (htmlContent, limit) => {
    const div = document.createElement("div");
    div.innerHTML = htmlContent;
  
    let charCount = 0;
    let reachedLimit = false;
  
    const truncateNode = (node) => {
      if (reachedLimit) return null;
  
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent || "";
        if (charCount + text.length <= limit) {
          charCount += text.length;
          return document.createTextNode(text);
        } else {
          const remaining = limit - charCount;
          charCount = limit;
          reachedLimit = true;
          return document.createTextNode(text.slice(0, remaining));
        }
      }
  
      if (node.nodeType === Node.ELEMENT_NODE) {
        const clone = node.cloneNode(false); // Shallow clone
        for (const child of node.childNodes) {
          const truncatedChild = truncateNode(child);
          if (truncatedChild) clone.appendChild(truncatedChild);
          if (reachedLimit) break;
        }
        return clone;
      }
  
      return null;
    };
  
    const truncated = truncateNode(div);
    const container = document.createElement("div");
    if (truncated) container.appendChild(truncated);
  
    return container.innerHTML;
  };

  const getAllPosts = async (page = 1, reset = false) => {
    if (reset) {
      setBusinessPosts([]);  
      setCurrentPage(1);    
      setHasMorePosts(true); 
    }
  
    try {
      setIsLoadingMore(true);
      const resp = await axios.get(
        `${GlobalConstants.townTicksBaseUrl}v1/posts?page=${page}`
      );
  
      if (resp.data.status) {
        const newPosts = resp.data.data;
       //remove reset ? [...newPosts] : [...prevPosts, ...newPosts]
      setBusinessPosts((prevPosts) => {
            const posts = reset ? newPosts : [...prevPosts, ...newPosts];

            return posts.filter(
                (post, index, self) =>
                index === self.findIndex((p) => p.id === post.id)
            );
        });
  
        if (newPosts.length < 10) {
          setHasMorePosts(false);
        } else {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      } else {
        toast.show({
          render: () => (
            <Toast color={GlobalStyles.colors.red} message="Failed to get posts!" />
          ),
          placement: "top",
        });
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      setIsLoadingMore(false);
    }
  };
  
  
  
  // Function to load more posts
  const loadMorePosts = () => {
    if (hasMorePosts) {
      getAllPosts(currentPage);
    }
  };

  const Delete = async () => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${GlobalConstants.townTicksBaseUrl}posts`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        post_id: selectedPost.id,
      }),
    };

    await axios
      .request(config)
      .then((resp) => {
        if (resp.data.status) {
          setBusinessPosts((prevPosts) =>
        prevPosts.filter((post) => post.id !== selectedPost.id)
        );
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.mustard}
              message="Post deleted successfully!"
            />
          ),
          placement: "top",
        });
          getAllPosts();
        } else {
          toast.show({
            render: () => {
              return (
                <Toast
                  color={GlobalStyles.colors.red}
                  message={resp.data.status_msg}
                />
              );
            },
            placement: "top",
          });
        }
      })
      .catch((error) => {
        toast.show({
          render: () => {
            return <Toast color={GlobalStyles.colors.red} message={error} />;
          },
          placement: "top",
        });
      });
  };

  const handleDeleteOk = async (isTrue) => {
    setDeletePopUp(false);
    if (isTrue) {
      await Delete();
    }
  };

  const onDeleteClick = async (data) => {
    // console.log(data);
    setDeletePopUp(true);
    setSelectedPost(data);
  };

  async function selectFile() {
    setIsLoading(true);
    let imageUrl = await uploadImage(user.token);
    if (imageUrl) {
      setPostImage((prev) => [...prev, imageUrl]);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      toast.show({
        render: () => {
          return (
            <Toast
              color={GlobalStyles.colors.red}
              message={"please check image size should be less than 500KB!!!"}
            />
          );
        },
        placement: "top",
      });
    }
  }

  ////// for scroll up to the top //////
 const [showUpButton, setShowUpButton] = useState(false);
 const scrollViewRef = useRef(null);
 const scrollToTop = () => {
   console.log("up to the screen.",scrollViewRef.current)
   if (scrollViewRef.current) {
     scrollViewRef.current.scrollTo({ y: 0, animated: true });
   }
 };
 const handleScroll = (event) => {
   const scrollY = event.nativeEvent.contentOffset.y;
   setShowUpButton(scrollY > 100); // Show button when user scrolls down 100px
 };
 const removeImage = (indexToRemove) => {
  setPostImage((prev) => prev.filter((_, idx) => idx !== indexToRemove));
};

  useEffect(async () => {
    console.log(window?.innerWidth || yourDefaultWidth);
    const updateLinkButton = () => {
      const toolbars = document.querySelectorAll(".ql-toolbar");

      toolbars.forEach((toolbar) => {
        const linkButton = toolbar.querySelector(".ql-formats");

        if (linkButton && !linkButton.classList.contains("customized")) {
          linkButton.classList.add("customized");

          const labelSpan = document.createElement("span");
          labelSpan.textContent = " Make hyperlink";
          labelSpan.style.marginLeft = "4px";
          labelSpan.style.fontSize = "14px";
          labelSpan.style.verticalAlign = "middle";

          linkButton.appendChild(labelSpan);
        }
      });
    };

    // Apply the update after component mounts
    updateLinkButton();
    changeColor("AddEvent");
  }, []);

  return (
    <>
      <ScrollView ref={scrollViewRef} onScroll={handleScroll}
        scrollEventThrottle={16}>
        <Center>
          <Box safeAreaTop bg="white" />

          <Box
            h={"550"}
            bg="#F5F5F5"
            px="1"
            py="3"
            justifyContent="space-between"
            alignItems="center"
            w="100%"
            maxW="900"
          >
            <VStack alignItems="center">
              <Stack
                mt={10}
                w={[230, 230, 230]}
                justifyContent="center"
                flexDirection={"row"}
              >
                <Button
                  size="sm"
                  mx={1}
                  variant={"solid"}
                  px="3"
                  bg={GlobalStyles.colors.blue}
                  borderColor={ticksBtnTextColor}
                  borderWidth={2}
                  onPress={() => {
                    setIsTicksView(true);
                    changeColor("Ticks");
                    getAllPosts();
                  }}
                >
                  <Text
                    fontWeight="bold"
                    fontFamily={GlobalStyles.text.fontFamily}
                    color={ticksBtnTextColor}
                  >
                    Ticks
                  </Text>
                </Button>
                <Button
                  size="sm"
                  variant={"solid"}
                  mx={1}
                  px="3"
                  bg={GlobalStyles.colors.blue}
                  borderColor={addEventBtnTextColor}
                  borderWidth={2}
                  onPress={() => {
                    changeColor("AddEvent");
                    setIsTicksView(false);
                    setPostType(GlobalConstants.postCategories.cityLen.id);
                  }}
                >
                  <Text
                    fontWeight="bold"
                    fontFamily={GlobalStyles.text.fontFamily}
                    color={addEventBtnTextColor}
                  >
                    New Tick
                  </Text>
                </Button>
                <Button
                  isDisabled={true}
                  size="sm"
                  variant={"solid"}
                  mx={1}
                  px="3"
                  bg={GlobalStyles.colors.blue}
                  borderColor={createAdBtnTextColor}
                  borderWidth={2}
                  onPress={() => {
                    changeColor("CreateAd");
                    setIsTicksView(false);
                    setPostType(GlobalConstants.postCategories.ad.id);
                  }}
                >
                  <Text
                    fontWeight="bold"
                    fontFamily={GlobalStyles.text.fontFamily}
                    color={createAdBtnTextColor}
                  >
                    Stats
                  </Text>
                </Button>
              </Stack>
              {isTicksView ? (
                <>
                  <ScrollView
                    w={[260, 360, 610]}
                    showsVerticalScrollIndicator={false}
                  >
                    <VStack alignItems="center">
                      <Stack
                        justifyContent="center"
                        flexDirection={"row"}
                        space={3}
                        flexWrap="wrap"
                        m={2}
                      >
                        {businessPosts.map((x, index) => {
                          return (
                            <FeedCardNew
                              data={x}
                              showViewCount={false}
                              setSelectedPost={onDeleteClick}
                            />
                          );
                        })}
                      </Stack>
                    </VStack>
                    {businessPosts.length >= 10 && hasMorePosts && (
                    <Stack
                      w={[190, 190, 190]}
                      alignSelf="center"
                      
                    >
                      <Button
                         size="sm"
                         bg={GlobalStyles.colors.blue}
                         onPress={loadMorePosts}
                         isLoading={isLoadingMore} 
                         isLoadingText="Loading..."
                       >
                         <Text
                           fontWeight="bold"
                           fontFamily={GlobalStyles.text.fontFamily}
                           color={GlobalStyles.colors.white}
                         >
                           Load More
                         </Text>
                       </Button>
                    </Stack>
                   )}
                  </ScrollView>
                </>
              ) : (
                <>
                  <Box mt={10} alignItems="center" w={[250, 350, 400]}>
                  <FormControl mt={2} w={[250, 350, 400]}>

                      {/* ================= IMAGE / VIDEO UPLOAD ================= */}

                      <Pressable
                        onPress={() => {
                          if (!youtubeLink) {
                            selectFile();
                          }
                        }}
                        isDisabled={youtubeLink?.length > 0}
                      >
                        <Input
                          isDisabled={youtubeLink?.length > 0}
                          value={
                            postImage.length > 0
                              ? `${postImage.length} file(s) selected`
                              : "Upload Images / Videos"
                          }
                          placeholder="Upload Images / Videos"
                          InputRightElement={
                            <Button
                              onPress={() => {
                                if (!youtubeLink) {
                                  selectFile();
                                }
                              }}
                              bgColor="gray.200"
                              isDisabled={youtubeLink?.length > 0}
                            >
                              <Icon
                                size="6"
                                color="muted.500"
                                as={<MaterialIcons name="file-upload" />}
                              />
                            </Button>
                          }
                        />
                      </Pressable>

                      {/* ================= YOUTUBE EMBED INPUT ================= */}
                      <Text mt={1} fontSize="xs" color="gray.500">
                         OR
                      </Text>
                      <Input
                        mt={4}
                        placeholder="Paste Youtube  Link"
                        value={youtubeLink}
                        onChangeText={(text) => setYoutubeLink(text)}
                        isDisabled={postImage.length > 0}
                        InputRightElement={
                          <Icon
                            mr={3}
                            size="5"
                            color="red.500"
                            as={<MaterialIcons name="ondemand-video" />}
                          />
                        }
                      />

                      {/* ================= PREVIEW ================= */}

                     <HStack flexWrap="wrap" mt={3} space={2}>
                        {Array.isArray(postImage) &&
                        postImage.map((img, idx) => (
                            <Box key={idx} position="relative">

                            <Image
                                source={{ uri: img }}
                                alt="preview"
                                size="md"
                                borderRadius={8}
                            />

                            <Pressable
                                position="absolute"
                                top={0}
                                right={0}
                                bg="red.500"
                                borderRadius="full"
                                p={1}
                                onPress={() => removeImage(idx)}
                            >
                                <Icon
                                as={<MaterialIcons name="close" />}
                                size="xs"
                                color="white"
                                />
                            </Pressable>

                            </Box>
                        ))}
                    </HStack>
                    </FormControl>

                    <FormControl mt={2} w={[250, 350, 400]}>

                      <Box
                          borderColor="gray.300"
                          borderWidth={1}
                          p={2}
                          minHeight={150}
                          maxHeight={150} 
                          overflow="auto" 
                          bgColor="white"
                        >
                          <ReactQuill
                            theme="snow"
                            value={postTextArea}
                            onChange={(value) => handleCountInputChange(value)}  // for web
                            onChangeText={(text) => handleCountInputChange(text)} // for android and ios
                            modules={{
                              toolbar: [
                                
                                ["link"],
                              ],
                            }}
                            formats={["link"]}
                            placeholder="Summary"
                            
                            // maxLength={300}
                          />
                          <style>
                              {`
                                .ql-toolbar {
                                  position: sticky;
                                  top: 0;
                                  background-color: white;
                                  z-index: 10;
                                }
    
                                .ql-container {
                                  max-height: 110px;
                                  overflow-y: auto;
                                }
    
                                .ql-tooltip {
                                  left: 0 !important;
                                  transform: translateX(0) !important;
                                  max-width: 100% !important;
                                  overflow: hidden !important;
                                  white-space: nowrap;
                                }
                              `}
                          </style>
                        </Box>

                      
                    </FormControl>
                    <Text alignSelf={"flex-end"} fontSize="xs" color={remainingCharacters === 0 ? "red.500" : "gray.500"}> 
                    {remainingCharacters === 0
                    ? "Character limit reached"
                    : `${remainingCharacters} characters remaining`}
                    </Text>

                    
                    <FormControl mt={2} w={[250, 350, 400]}>
                      <Box
                        borderColor="gray.300"
                        borderWidth={1}
                        p={2}
                        minHeight={150}
                        maxHeight={150} 
                        overflow="auto" 
                        bgColor="white"
                      >
                        <ReactQuill
                          theme="snow"
                          value={postDetails}
                          onChange={(value) => handleCountInputChangeForDetail(value)} // for web
                          onChangeText={(text) => handleCountInputChangeForDetail(text)} // for android and ios
                          modules={{
                            toolbar: [
                              
                              ["link"],
                            ],
                          }}
                          formats={["link"]}
                          placeholder="Write the details here..."
                          // maxLength={1500}
                        />
                      </Box>
                    </FormControl>
                    <Text alignSelf={"flex-end"} fontSize="xs" color={remainingCharactersForDetail === 0 ? "red.500" : "gray.500"}> 
                    {remainingCharactersForDetail === 0
                    ? "Character limit reached"
                    : `${remainingCharactersForDetail} characters remaining`}
                    </Text>
                    <Button
                      size="sm"
                      variant={"solid"}
                      mx={1}
                      px="3"
                      bg={GlobalStyles.colors.blue}
                      borderColor={GlobalStyles.colors.mustard}
                      borderWidth={2}
                      onPress={() => {
                        createPost();
                      }}
                    >
                      <Text
                        fontWeight="bold"
                        fontFamily={GlobalStyles.text.fontFamily}
                        color={GlobalStyles.colors.white}
                      >
                        Submit
                      </Text>
                    </Button>
                  </Box>
                </>
              )}
            </VStack>
            {deletePopUp ? (
              <ConfigureSettingsPopup
                heading="Confirm Deletion"
                body="Are you sure you want to delete"
                data={deletePopUp}
                onChange={handleDeleteOk}
              />
            ) : (
              <></>
            )}
          </Box>
        </Center>
      </ScrollView>
      {showUpButton && isTicksView && (
         <IconButton
         position="absolute"
         bottom={10}
         right={10}
         borderRadius="full"
         bg={GlobalStyles.colors.blue}
         _pressed={{ bg: "gray.500" }}
         icon={<ChevronUpIcon color="white" size={6} />}
         onPress={scrollToTop}
       />
      )}
    </>
  );
};

export default CityLensMainPage;
